export function resolveColor(
  color: string
): string {

  if (color.startsWith('var(')) {

    const matches = color.match(/var\((--[^,]+)(?:, ([^)]+))?\)/);

    if (matches) {

      const cssVariableName = matches[1].trim();
      const fallback = matches[2]?.trim();

      const rootStyle = getComputedStyle(document.documentElement);
      const resolvedValue = rootStyle.getPropertyValue(cssVariableName).trim();

      return resolvedValue || fallback || 'transparent';
    }
  }

  return color;
}
